export function hidePlayerControlRefs(refs = {}) {
  if (refs.customMarkTitle?.isShow) return false

  if (refs.volume) refs.volume.isShow = false
  if (refs.speed) refs.speed.isShow = false
  if (refs.markPopover) refs.markPopover.isShow = false
  return true
}
